import { Globe } from 'lucide-react';
import type { PluginDefinition } from '../types';
import {
  PortalClienteConfigComponent,
  type PortalClienteConfig,
} from './ConfigComponent';
import { PortalClientePageComponent } from './PageComponent';

export const portalClientePlugin: PluginDefinition<PortalClienteConfig> = {
  slug: 'portal-cliente',
  icon: Globe,
  defaultConfig: {},
  ConfigComponent: PortalClienteConfigComponent,
  PageComponent: PortalClientePageComponent,
};

export { PortalClientePageComponent };
export type { PortalClienteConfig };
